import { createImperativePromise } from 'awesome-imperative-promise';

// see https://stackoverflow.com/a/54825370/82609
function onlyResolvesLast(asyncFunction) {
  var cancelPrevious = null;
  var wrappedFunction = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    cancelPrevious && cancelPrevious();
    var initialPromise = asyncFunction.apply(void 0, args);
    var _a = createImperativePromise(initialPromise),
      promise = _a.promise,
      cancel = _a.cancel;
    cancelPrevious = cancel;
    return promise;
  };
  return wrappedFunction; // TODO fix TS
}
export { onlyResolvesLast };